import http from '../http'

const api = {
    // 获取页面配置
    getPageInfo(params) {
        return http.get('/wp-json/dt_api/page_info', {
            params,
        })
    },
}

const state = {
    banners: [],
    pageTitle: '',
    service: {
        data: [],
    },
}

const mutations = {
    GET_BANNERS: state => {
        return state
    },
    SET_BANNERS: (state, {banners}) => {
        state.banners = banners
    },
    SET_PAGE_TITLE: (state, {pageTitle}) => {
        state.pageTitle = pageTitle
    },
    SET_SERVICE: (state, {service}) => {
        state.service = service
    },
}

// 所有的mutations转换成actions进行调用
const actions = {
    async getPageInfo({commit}) {
        commit('GET_BANNERS')
        const lang = window.localStorage.getItem('lang')

        await api.getPageInfo({
            slug: 'service',
            lang,
        }).then(res => {
            if (res.data.data) {
                commit('SET_BANNERS', {
                    banners: res.data.data.banner_pictures || [],
                })
                commit('SET_PAGE_TITLE', {
                    pageTitle: res.data.data.title,
                })

                commit('SET_SERVICE', {
                    service: res.data.data,
                })

                commit('common/SET_PAGE_THEME',  {
                    theme: res.data.data.theme
                }, {root: true})
                commit('common/SET_THEME',  {
                    theme: res.data.data.theme,
                    wxShare: res.data.data.wechat_share,
                }, {root: true})
            }
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
